<template>
  <div class="card-wrapper">
    <div class="list-checkbox" v-if="!isNew && contentType === 'my'">
      <input
        type="checkbox"
        v-model="content.checked"
        :id="content.id"
      />
      <label :for="content.id"></label>
    </div>
    <div class="card-contents">
      <div class="image-container">
        <div class="image-wrapper">
          <img
            crossorigin="anonymous"
            alt="capture"
            :src="content.captureUrl"
            :class="{ 'loaded': isLoaded }"
            @load="onLoaded"
            @error="onErrored"
            ref="capture"
          />
        </div>
        <div v-if="isExtTypeNameEcV1 && content.ecContentId != null" class="tmpl-id">
          <p>
            メールテンプレートID:
          </p>
          <p>
            {{ content.ecContentId }}
          </p>
        </div>
      </div>
      <div class="info" v-if="isShowInfo">
        <div v-if="contentType === 'my'" class="id">
          <div><span>ID</span>{{ content.code }}</div>
          <div v-if="kind === 'zip_export'" class="zip-export">
            {{ content.kind == 'rel_export' ? '相対パス' : '絶対パス' }}
         </div>
        </div>
        <div class="name-box">
          <div
            v-if="contentType === 'my' && content.showInput.name"
            key="name"
            class="main-input"
          >
            <input
              type="text"
              v-model="content.name"
              @keypress.enter="$event.target.blur"
              @blur="$emit('toggleSave', content, 'name', index)"
              :ref="'name' + index"
            />
          </div>
          <div
            v-else
            key="name"
          >
            <template v-for="planName in content.planNames">
              <div v-if="contentType !== 'my' && !content.available" class="plan" :key="planName">
                {{ planName }}
              </div>
            </template>
            <span class="name">{{ content.name }}</span>
          </div>
          <span
            class="pen"
            v-if="!isNew && contentType === 'my' && kind === 'origin' && !content.showInput.name"
            @click="$emit('toggleShowInput', content, 'name', index)"
          >
            <i class="fas fa-pen"></i>
          </span>
        </div>
        <div v-if="contentType === 'my'" class="update-info">
          <span class="info-key">更新者</span><span>：{{ content.savedUserName }}</span>
        </div>
        <div v-if="contentType === 'my'" class="update-info">
          <span class="info-key">更新日時</span><span>：{{ content.savedOn }}</span>
        </div>
        <div v-if="contentType === 'my'" class="update-info">
          <span class="info-key">サイズ</span><span>：{{ Math.ceil(content.size / 1024).toLocaleString() }}KB</span>
        </div>
        <template v-if="contentType === 'my' && content.kind === 'hosting'">
          <div class="update-info">
            <span>検索結果に表示</span><span>：{{ content.flgSearchIndex ? 'する' : 'しない' }}</span>
          </div>
        </template>
        <template v-if="!isNew && content.expireCountDown">
          <div class="expire-count-down">
            <span>{{ content.kind === 'rel_export' ? '保存期限' : '公開期限' }} {{ content.expireCountDown }}</span>
            <a v-if="kind === 'hosting'" :href="content.hostingUrl" target="_blank"><i class="fas fa-external-link-alt"></i></a>
          </div>
        </template>
        <ul class="tmpl-tag">
          <li v-for="(tag, index) in content.tags" :key="index">{{tag.name}}</li>
        </ul>
      </div>
      <div class="tmpl-nav" v-if="isShowInfo">
        <ul class="main">
          <template v-if="contentType === 'my'">
            <template v-if="isNew">
              <li class="preview"><a @click="$emit('htmlPreview', content)">プレビュー</a></li>
              <li class="copy"><a @click="$emit('copy', content)">コピーして作成</a></li>
            </template>
            <template v-else>
              <template v-if="kind === 'origin'">
                <li class="preview"><a @click="$emit('htmlPreview', content)">プレビュー</a></li>
                <li class="edit"><router-link :to="{name: 'contentEdit', params:{id: id}}">編集</router-link></li>
                <li class="others">
                  <a @click="othersFlag = !othersFlag" v-on-clickaway="othersHidden">その他</a>
                  <transition>
                    <ul class="other" v-show="othersFlag">
                      <li class="copy"><a @click="$emit('copy', content)">コピーして作成</a></li>
                      <li class="delete"><a @click="$emit('deleteConfirm', content)">削除</a></li>
                    </ul>
                  </transition>
                </li>
              </template>
              <template v-if="kind === 'mp'">
                <li class="preview"><a @click="$emit('htmlPreview', content)">プレビュー</a></li>
                <li class="copy"><a @click="$emit('copy', content)">コピーして作成</a></li>
                <li class="delete"><a @click="$emit('deleteConfirm', content)">削除</a></li>
              </template>
              <template v-if="kind === 'ec_v1'">
                <li class="preview"><a @click="$emit('htmlPreview', content)">プレビュー</a></li>
                <li class="copy"><a @click="$emit('copy', content)">コピーして作成</a></li>
                <li class="delete"><a @click="$emit('deleteConfirm', content)">削除</a></li>
              </template>
              <template v-if="kind === 'ec_v2'">
                <li class="preview"><a @click="$emit('htmlPreview', content)">プレビュー</a></li>
                <li class="copy"><a @click="$emit('copy', content)">コピーして作成</a></li>
                <li class="delete"><a @click="$emit('deleteConfirm', content)">削除</a></li>
              </template>
              <template v-if="kind === 'mp_lite'">
                <li class="preview"><a @click="$emit('htmlPreview', content)">プレビュー</a></li>
                <li class="copy"><a @click="$emit('copy', content)">コピーして作成</a></li>
                <li class="delete"><a @click="$emit('deleteConfirm', content)">削除</a></li>
              </template>
              <template v-if="kind === 'mp_next'">
                <li class="preview"><a @click="$emit('htmlPreview', content)">プレビュー</a></li>
                <li class="copy"><a @click="$emit('copy', content)">コピーして作成</a></li>
                <li class="delete"><a @click="$emit('deleteConfirm', content)">削除</a></li>
              </template>
              <template v-if="kind === 'hosting'">
                <li class="preview"><a @click="$emit('htmlPreview', content)">プレビュー</a></li>
                <li class="copy"><a @click="$emit('copy', content)">コピーして作成</a></li>
                <li class="delete"><a @click="$emit('deleteConfirm', content)">削除</a></li>
              </template>
              <template v-if="kind === 'zip_export'">
                <li class="preview"><a @click="$emit('htmlPreview', content)">プレビュー</a></li>
                <li class="copy"><a @click="$emit('copy', content)">コピーして作成</a></li>
                <li class="download"><a @click="$emit('download', content)">ダウンロード</a></li>
                <li class="delete"><a @click="$emit('deleteConfirm', content)">削除</a></li>
              </template>
            </template>
          </template>
          <template v-if="contentType !== 'my' && content.available" >
            <li class="preview"><a @click="$emit('htmlPreview', content)">プレビュー</a></li>
            <li class="new"><a @click="$emit('createContent', content)">新規作成</a></li>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mixin as onClickAway } from 'vue-clickaway'

export default {
  props: [
    'content',
    'id',
    'index',
    'contentType',
    'isNew',
    'kind',
    'isShowInfo',
    'extTypeName',
  ],
  mixins: [
    onClickAway
  ],
  data () {
    return {
      othersFlag: false,
      isLoaded: false
    }
  },
  computed: {
    isExtTypeNameEcV1 () {
      return this.extTypeName === 'ec_v1'
    },
  },
  methods: {
    othersHidden () {
      this.othersFlag = false
    },
    onLoaded () {
      this.isLoaded = true
    },
    onErrored (event) {
      this.isLoaded = true
      this.$emit('captureError', event)
    }
  }
}
</script>

<style lang="scss" scoped>
a {
  color: $commonFontColor;
}
.card-wrapper {
  padding: 20px;
  padding-right: 0;
  border-bottom: 0.5px solid #C6C6C6;
  margin: 0 20px;
  position: relative;
  &:first-of-type {
    border-top: 0.5px solid #C6C6C6;
  }
  &:hover {
    background: rgba(84, 150, 232, 0.1);
  }
  // 一括操作のチェックボックス
  .list-checkbox {
    position: absolute;
    top:20px;
    left: 0;
    input[type=checkbox] {
      display:  none;
      + label {
        font-size: 12px;
        margin-bottom: 0;
        display: inherit;
        line-height: 20px;
        &::before {
          width: 20px;
          height: 20px;
          vertical-align: bottom;
          margin-right: 8px;
          display: inline-block;
          content: '';
          border-radius: 4px;
          background: #cfcfcf;
        }
      }
      &:checked + label::before {
        font-size: 14px;
        box-sizing: border-box;
        font-family: "Font Awesome 5 Free";
        padding-left: 3px;
        content: '\f00c';
        display: inline-block;
        font-weight: 900;
      }
    }
    + .card-contents {
      margin-left: 20px;
      min-height: 148px;
    }
  }
  .card-contents {
    display:flex;
    align-items: center;
    // テンプレート画像
    .image-wrapper {
      width: 130px;
      background: #fff;
      overflow: hidden;
      display: inline-block;
      img {
        opacity: 0;
        width: 130px;
        height: 130px;
        object-fit: contain;
        transition: all 0.3s ease 0s;
        &.loaded {
          opacity: 1;
        }
      }
    }
    .image-container {
      .tmpl-id {
        color: rgba(#484848, 0.6);
        font-size: 12px;
        width: 130px;
        word-break: break-all;
        p {
          &:nth-of-type(2) {
            text-align: center;
          }
        }
      }
    }
    // タイトル・ 日付・タグ
    .info {
      max-width: calc(100% - 430px);
      padding: 10px;
      padding-left: 50px;
      display: inline-block;
      flex: 1;
      .id {
        font-size: 12px;
        color: rgba(#484848, 0.6);
        margin-bottom: 5px;
        display: flex;
        span {
          display: inline-block;
          text-align: center;
          border-radius: 12px;
          background: #e4e4e4;
          width: 30px;
          height: 19px;
          margin-right: 8px;
        }
        .zip-export {
          font-size: 14px;
          color: $commonFontColor;
          height: 20px;
          line-height: 20px;
          max-width: 190px;
          display: inline-block;
          padding: 0 10px;
          margin: 0 5px 0 5px;
          background: #fff;
          border-radius: 12px;
        }
      }
      .name-box {
        font-size: 16px;
        font-weight: bold;
        display: flex;
        flex: 1;
        > div {
          overflow: hidden;
        }
        .name {
          display: inline-block;
          width: 100%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        span {
          cursor: pointer;
        }
        .main-input {
          min-width: 300px;
          margin-top: 0;
        }
      }
      .pen {
        padding-left: 3px;
      }
      .update-info {
        .info-key {
          display: inline-block;
          width: 57px;
        }
      }
      .tmpl-tag {
        margin-top: 5px;
        li {
          height: 24px;
          line-height: 24px;
          max-width: 190px;
          display: inline-block;
          padding: 0 10px;
          margin: 0 5px 5px 0;
          background: #fff;
          border-radius: 12px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          transition: all 0.3s ease 0s;
          &:hover, &:active {
            background: #e4e4e4;
            transition: all 0.3s ease 0s;
          }
        }
      }
      .expire-count-down {
        font-size: 14px;
        margin-top: 2px;
        a {
          display: inline-block;
          padding-left: 10px;
        }
      }
      .mp {
        p {
          font-size: 14px;
        }
        span {
          font-size: 12px;
        }
      }
      .web {
        p {
          font-size: 14px;
        }
        span {
          font-size: 12px;
        }
        margin-top: 5px;
      }
      .plan {
        background-color: #FFB135;
        border-radius: 20px;
        color: #FFFFFF;
        text-align: center;
        margin-bottom: 5px;
      }
    }
    // 右側のメニュー
    .tmpl-nav {
      width: 288px;
      display: flex;
      justify-content: flex-end;
      .main {
        display:-webkit-box;
        display:flex;
        margin: 0;
        > li {
          width: 96px;
          height: 64px;
          white-space: nowrap;
          font-weight: 300;
          border-radius: 2px;
          transition: all 0.3s ease 0s;
          text-align: center;
          cursor: pointer;
          &:hover, &:active {
            background: #e4e4e4;
            transition: all 0.3s ease 0s;
            border-radius: 2px;
          }
          a {
            padding: 11px 0;
            display: block;
            &::before {
              font-family: "Font Awesome 5 Free";
              display: block;
              text-align: center;
            }
          }
          &.edit {
            a::before {
              content: '\f044';
              font-weight: 900;
            }
          }
          &.preview {
            a::before {
              content: '\f06e';
            }
          }
          &.others {
            position: relative;
            > a::before {
              content: '\f142';
              font-weight: 900;
            }
          }
          &.copy {
            a::before {
              content: '\f0c5';
            }
          }
          &.delete {
            a::before {
              content: '\f2ed';
            }
          }
          &.download {
            a::before {
              content: '\f019';
              font-weight: 900;
            }
          }
          &.new {
            a::before {
              content: '\f067';
              font-weight: 900;
            }
          }
        }
      }
      // 右側のメニュー の その他
      .other {
        background: #fff;
        border-radius: 2px;
        padding: 20px 0;
        position: absolute;
        z-index: 1;
        top: 100%;
        right: 0;
        box-shadow: 0 3px 4px rgba(198,198,198,0.5);
        overflow: hidden;
        > li {
          width: 100%;
          height: unset;
          white-space: nowrap;
          border-radius: 2px;
          transition: all 0.3s ease 0s;
          text-align: left;
          line-height: 2;
          a {
            padding: 0 20px;
            &:hover, &:active {
              background: #ececec;
              transition: all 0.3s ease 0s;
            }
            &::before {
              font-family: "Font Awesome 5 Free";
              padding-right: 8px;
              text-align: left;
              display: inline-block;
            }
          }
        }
      }
      // その他クリック時のアニメーション
      .v-enter-active, .v-leave-active {
        transition: all .1s;
      }
      .v-enter,.v-leave-to {
        height: 0;
        opacity: 0;
      }
      .v-enter-to, .v-leave {
        height: 152px;
        opacity: 1;
      }
    }
  }
}
</style>
